import type { Root, Content } from "mdast";

/** Keep document chips inside the assistant's existing Markdown tree. */
export function remarkDocumentMentions() {
  function visit(node: Root | Content) {
    if (!("children" in node)) return;
    node.children.forEach((child, index) => {
      if (child.type === "link" && child.url.startsWith("document::") && child.url.length > 10) {
        child.data = {
          ...child.data,
          hProperties: { ...(child.data?.hProperties as Record<string, unknown> | undefined), "data-document-mention": child.url },
        };
        // The chip supplies its own #; remove only an adjacent mention marker.
        const previous = node.children[index - 1];
        if (previous?.type === "text") previous.value = previous.value.replace(/[@#]$/, "");
      }
      visit(child);
    });
  }
  return visit;
}
